import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ExternalLink, AlertTriangle } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { Button } from '../components/ui/Button';
export function HelpGoogleSheetsPage() {
  return <div className="min-h-screen bg-gray-50" dir="rtl" data-id="element-1932">
      <Navbar data-id="element-1933" />

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1934">
        <Link to="/configure" className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6" data-id="element-1935">
          <ArrowRight className="ml-2 w-4 h-4" data-id="element-1936" />
          رجوع إلى الإعدادات
        </Link>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-1937">
          <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50" data-id="element-1938">
            <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1939">
              كيفية ربط Google Sheets
            </h1>
            <p className="text-gray-600" data-id="element-1940">
              اتبع الخطوات التالية للحصول على Client ID و Client Secret من
              Google Cloud Console
            </p>
          </div>

          <div className="p-8 space-y-8" data-id="element-1941">
            {/* Warning */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 flex items-start gap-3" data-id="element-1942">
              <AlertTriangle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" data-id="element-1943" />
              <div className="text-sm text-yellow-800" data-id="element-1944">
                <strong data-id="element-1945">تحذير أمني:</strong> لا تشارك Client Secret مع أي شخص.
                احتفظ به في مكان آمن.
              </div>
            </div>

            {/* Steps */}
            <div className="space-y-6" data-id="element-1946">
              <div className="flex gap-4" data-id="element-1947">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-1948">
                  1
                </div>
                <div className="flex-1" data-id="element-1949">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1950">
                    افتح Google Cloud Console
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1951">
                    انتقل إلى{' '}
                    <a href="https://console.cloud.google.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline inline-flex items-center gap-1" data-id="element-1952">
                      Google Cloud Console
                      <ExternalLink size={14} data-id="element-1953" />
                    </a>
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1954">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1955">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-1956">
                  2
                </div>
                <div className="flex-1" data-id="element-1957">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1958">
                    أنشئ مشروع جديد أو اختر مشروع موجود
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1959">
                    من القائمة العلوية، اضغط على اسم المشروع واختر "New Project"
                    أو اختر مشروعاً موجوداً.
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1960">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1961">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-1962">
                  3
                </div>
                <div className="flex-1" data-id="element-1963">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1964">
                    فعّل Google Sheets API
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1965">
                    اذهب إلى "APIs & Services" → "Enable APIs and Services" →
                    ابحث عن "Google Sheets API" وفعّله.
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1966">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1967">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-1968">
                  4
                </div>
                <div className="flex-1" data-id="element-1969">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1970">
                    أنشئ OAuth 2.0 Credentials
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1971">
                    اذهب إلى "Credentials" → "Create Credentials" → "OAuth
                    client ID"
                  </p>
                  <ul className="list-disc list-inside text-gray-600 space-y-1 mb-3" data-id="element-1972">
                    <li data-id="element-1973">Application type: Web application</li>
                    <li data-id="element-1974">Name: Operiens Integration</li>
                    <li data-id="element-1975">
                      Authorized redirect URIs: أضف الرابط من صفحة الإعدادات
                    </li>
                  </ul>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1976">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1977">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-1978">
                  5
                </div>
                <div className="flex-1" data-id="element-1979">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1980">
                    انسخ Client ID و Client Secret
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1981">
                    بعد إنشاء الـ OAuth client، ستظهر لك نافذة تحتوي على Client
                    ID و Client Secret. انسخهما والصقهما في صفحة الإعدادات.
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1982">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>
            </div>

            {/* Video Tutorial */}
            <div className="border-t border-gray-100 pt-8" data-id="element-1983">
              <h3 className="font-bold text-gray-900 mb-4" data-id="element-1984">شرح بالفيديو</h3>
              <div className="bg-gray-100 rounded-lg aspect-video flex items-center justify-center text-gray-500" data-id="element-1985">
                [فيديو يوتيوب - سيتم إضافته]
              </div>
            </div>

            {/* CTA */}
            <div className="border-t border-gray-100 pt-8" data-id="element-1986">
              <Link to="/configure" data-id="element-1987">
                <Button size="lg" fullWidth data-id="element-1988">
                  رجوع إلى الإعدادات
                  <ArrowRight className="mr-2 w-5 h-5" data-id="element-1989" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>;
}